import AdminSection from '../../../../AdminSection';
import CollapsableCard from '../../../../CollapsableCard';

const AdminSectionWrapper = ({
  //CollapsableCard props
  collapsedSections,
  toggleCollapse,
  id,
  title,
  //AdminSection props
  customerOrder,
  ...adminModelProps
}) => {
  return (
    <CollapsableCard
      collapsedSections={collapsedSections}
      toggleCollapse={toggleCollapse}
      key={id}
      id={id}
      title={title}
      className="quote-card-container"
      contentWrapperClassName="full-width"
    >
      <AdminSection customerOrder={customerOrder} {...adminModelProps} />
    </CollapsableCard>
  );
};

export default AdminSectionWrapper;
